import { isChildWithdrawn } from "./childDetailsFormatters";

export const CHILD_PLACEMENT_STATUS = {
  WAITING: "WAITING",
  PLANNED: "PLANNED",
  ACTIVE: "ACTIVE",
  UNASSIGNED: "UNASSIGNED",
  WITHDRAWN: "WITHDRAWN",
};

export const deriveChildPlacementStatus = (child, { currentClassrooms = [], futureClassrooms = [] } = {}) => {
  if (isChildWithdrawn(child)) return CHILD_PLACEMENT_STATUS.WITHDRAWN;
  if (child?.waiting) return CHILD_PLACEMENT_STATUS.WAITING;
  if (currentClassrooms.length > 0) return CHILD_PLACEMENT_STATUS.ACTIVE;
  if (futureClassrooms.length > 0) return CHILD_PLACEMENT_STATUS.PLANNED;
  return CHILD_PLACEMENT_STATUS.UNASSIGNED;
};

export const getPlacementStatusCopy = (status, t) => {
  const copy = {
    WAITING: {
      label: t("children.details.waiting", { defaultValue: "On waiting list" }),
      helper: t("children.details.waiting_helper", { defaultValue: "Awaiting placement" }),
      tone: "amber",
    },
    PLANNED: {
      label: t("children.details.planned", { defaultValue: "Planned" }),
      helper: t("children.details.planned_helper", { defaultValue: "Future placement" }),
      tone: "sky",
    },
    ACTIVE: {
      label: t("children.details.active", { defaultValue: "Enrolled" }),
      helper: t("children.details.active_helper", { defaultValue: "Active placement" }),
      tone: "emerald",
    },
    UNASSIGNED: {
      label: t("children.details.unassigned", { defaultValue: "Not assigned" }),
      helper: t("children.details.unassigned_helper", { defaultValue: "No placement" }),
      tone: "slate",
    },
    WITHDRAWN: {
      label: t("children.details.withdrawn", { defaultValue: "Withdrawn" }),
      helper: t("children.details.withdrawn_banner", {
        defaultValue: "This child has been withdrawn.",
      }),
      tone: "rose",
    },
  };

  return copy[status] || copy.UNASSIGNED;
};
